import { callAPI } from '../network';

export async function getVacationDataByPeriod(params) {
    const data = await callAPI(
        params, 
                           'Vacation/GetDataByPeriod', 'post');
      return data || [ ];
}


export async function saveRequestService(payload) {
    return await callAPI(payload, 'Vacation/SaveRequest', 'post');
}

export async function getDataVacationRequest(params){
    const data = await callAPI(
                        null, 
                        `Vacation/GetDataVacationRequest${params}`, 'get');
    return data || [];
}